/**
 * We've never had more units than this for a single item in a package,
 * except for kfc firelogs, which was probably a hack.
 */
export const MAX_UNITS_PER_PACKAGE = 5000;
